import {FILTER_NAMES} from '../base.js'
import {FILTERS_GROUPS_IDS} from './filtersGroups.js'

export const FILTERS_LABELS = {
  [FILTER_NAMES.EXCLUDED_VEHICLES]: 'FILTERS.EXCLUDED_VEHICLES.LABEL',
  [FILTER_NAMES.ELECTRIC_AUTONOMY]: 'FILTERS.ELECTRIC_AUTONOMY.LABEL',
  [FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: 'FILTERS.ELECTRIC_BATTERY_CAPACITY.LABEL',
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: 'FILTERS.ELECTRIC_CHARGING_TIME_FAST_MODE.LABEL',
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: 'FILTERS.ELECTRIC_CHARGING_TIME_STANDARD_MODE.LABEL',
  [FILTER_NAMES.FINANCING_ENTRY]: 'FILTERS.FINANCING_ENTRY.LABEL',
  [FILTER_NAMES.FINANCING_TERMS]: 'FILTERS.FINANCING_TERMS.LABEL',
  [FILTER_NAMES.HAS_ONLINE_FINANCING]: 'FILTERS.HAS_ONLINE_FINANCING.LABEL',
  [FILTER_NAMES.HAS_PRICE_DROP]: 'FILTERS.HAS_PRICE_DROP.LABEL',
  [FILTER_NAMES.HAS_RESERVATION]: 'FILTERS.HAS_RESERVATION.LABEL',
  [FILTER_NAMES.HAS_STOCK]: 'FILTERS.HAS_STOCK.LABEL',
  [FILTER_NAMES.LOCATION]: 'FILTERS.LOCATION.LABEL',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: 'FILTERS.MONTHLY_SUBSCRIPTION_COMMITMENT.LABEL',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE]: 'FILTERS.MONTHLY_SUBSCRIPTION_FEE.LABEL',
  [FILTER_NAMES.PRICE_RANK]: 'FILTERS.PRICE_RANK.LABEL',
  [FILTER_NAMES.RATING]: 'FILTERS.RATING.LABEL'
}

export const FILTERS_GROUPS_LABELS = {
  [FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID]: 'FILTERS_GROUPS.ELECTRIC_CHARGING_TIME_GROUP.LABEL'
}
